var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"placement":"top-start","width":"400","trigger":"click"}},[_c('div',{staticClass:"emotionList"},_vm._l((_vm.faceList),function(item,idx){return _c('b',{key:idx,staticClass:"emotionItem",on:{"click":function($event){return _vm.getEmo(idx)}}},[_vm._v(_vm._s(item))])}),0),_vm._t("default",null,{"slot":"reference"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }